import { createFileRoute } from "@tanstack/react-router";

import { requireAuthenticated } from "../router/auth";
import { RouterOutlet, RouterPending } from "../router/components";

export const Route = createFileRoute("/_protected")({
  component: RouterOutlet,
  pendingComponent: RouterPending,
  pendingMs: 0,
  beforeLoad: async ({ context, location, abortController }) => ({
    authSnapshot: await requireAuthenticated(
      context.auth,
      location,
      abortController.signal,
    ),
  }),
});
